import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const bulkRefreshInventoryCodes = async (inventoryIds) => {
	const { data } = await axios.post(`${API}/app/inventory/codes/bulk-refresh`, {
		inventory_ids: inventoryIds,
	});
	return data;
};
